import { useState, useRef } from 'react';
import logoImg from '../assets/d1fe1a9231ec0614e594fed0b7cebc9d8b920db6.png';
import apiClient from '../services/api-client';

const CSS = `
  .comp-reg-root {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    background: #0A0A0A;
    color: #FFFFFF;
    min-height: 100vh;
  }
  .comp-reg-root * { box-sizing: border-box; margin: 0; padding: 0; }

  .cr-header {
    background: #0A0A0A;
    border-bottom: 1px solid rgba(212,175,55,0.35);
    padding: 36px 24px 44px;
    text-align: center;
    position: relative;
    overflow: hidden;
  }
  .cr-header::before {
    content: '';
    position: absolute; inset: 0;
    background: radial-gradient(ellipse at 50% -20%, rgba(212,175,55,0.13) 0%, transparent 60%);
    pointer-events: none;
  }
  .cr-logo {
    height: 54px;
    width: auto;
    margin: 0 auto 28px;
    display: block;
    position: relative;
  }
  .cr-prize-badge {
    display: inline-block;
    background: linear-gradient(135deg, #D4AF37 0%, #F0D060 100%);
    color: #0A0A0A;
    font-size: 40px;
    font-weight: 900;
    padding: 12px 36px;
    border-radius: 10px;
    letter-spacing: -1px;
    margin-bottom: 14px;
    position: relative;
  }
  .cr-header h1 {
    font-size: 26px;
    font-weight: 800;
    margin-bottom: 10px;
    line-height: 1.2;
    letter-spacing: -0.3px;
  }
  .cr-header p {
    color: rgba(255,255,255,0.70);
    font-size: 15px;
    max-width: 440px;
    margin: 0 auto;
    line-height: 1.65;
  }

  .cr-steps {
    background: #111111;
    border-bottom: 1px solid rgba(212,175,55,0.15);
    padding: 28px 24px;
  }
  .cr-steps-inner { max-width: 600px; margin: 0 auto; }
  .cr-steps h2 {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.18em;
    color: #D4AF37;
    text-transform: uppercase;
    margin-bottom: 18px;
  }
  .cr-step-list { display: grid; gap: 14px; }
  .cr-step {
    display: flex;
    align-items: flex-start;
    gap: 14px;
    font-size: 14px;
    color: rgba(255,255,255,0.70);
    line-height: 1.55;
  }
  .cr-step-num {
    width: 26px; height: 26px;
    border-radius: 50%;
    background: linear-gradient(135deg, #D4AF37, #F0D060);
    color: #0A0A0A;
    font-size: 11px;
    font-weight: 900;
    display: flex; align-items: center; justify-content: center;
    flex-shrink: 0;
    margin-top: 1px;
  }
  .cr-step strong { color: #FFFFFF; }

  .cr-form-wrap {
    max-width: 560px;
    margin: 0 auto;
    padding: 36px 24px 52px;
  }
  .cr-form-title { font-size: 22px; font-weight: 800; margin-bottom: 6px; letter-spacing: -0.3px; }
  .cr-form-subtitle { font-size: 14px; color: rgba(255,255,255,0.45); margin-bottom: 28px; }
  .cr-form-divider {
    width: 40px; height: 2px;
    background: linear-gradient(90deg, #D4AF37, transparent);
    margin-bottom: 28px;
  }

  .cr-field { margin-bottom: 18px; }
  .cr-label {
    display: block;
    font-size: 11px; font-weight: 700; letter-spacing: 0.1em;
    color: rgba(255,255,255,0.45);
    text-transform: uppercase; margin-bottom: 8px;
  }
  .cr-input, .cr-select, .cr-textarea {
    width: 100%;
    background: #1A1A1A;
    border: 1px solid rgba(255,255,255,0.10);
    border-radius: 10px;
    padding: 14px 16px;
    font-size: 15px;
    color: #FFFFFF;
    outline: none;
    transition: border-color 0.2s, background 0.2s;
    -webkit-appearance: none; appearance: none;
    font-family: inherit;
  }
  .cr-input::placeholder, .cr-textarea::placeholder { color: rgba(255,255,255,0.20); }
  .cr-input:focus, .cr-select:focus, .cr-textarea:focus {
    border-color: #D4AF37; background: #222222;
  }
  .cr-select option { background: #1A1A1A; color: #FFFFFF; }
  .cr-textarea { resize: vertical; min-height: 90px; }

  .cr-row { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
  @media (max-width: 480px) { .cr-row { grid-template-columns: 1fr; } }

  .cr-submit-btn {
    width: 100%;
    background: linear-gradient(135deg, #D4AF37 0%, #F0D060 100%);
    color: #0A0A0A;
    border: none; border-radius: 10px;
    padding: 17px;
    font-size: 16px; font-weight: 800;
    cursor: pointer; letter-spacing: 0.03em; margin-top: 10px;
    transition: opacity 0.2s, transform 0.1s;
  }
  .cr-submit-btn:hover { opacity: 0.90; }
  .cr-submit-btn:active { transform: scale(0.99); }
  .cr-submit-btn:disabled { opacity: 0.40; cursor: not-allowed; }

  .cr-terms-box {
    background: rgba(212,175,55,0.08);
    border: 1px solid rgba(212,175,55,0.35);
    border-radius: 10px;
    padding: 16px 20px; margin-top: 22px;
  }
  .cr-terms-box h4 {
    font-size: 10px; font-weight: 700; letter-spacing: 0.15em;
    text-transform: uppercase; color: #D4AF37; margin-bottom: 10px;
  }
  .cr-terms-list { list-style: none; padding: 0; margin: 0; display: grid; gap: 5px; }
  .cr-terms-item {
    font-size: 12px; color: rgba(255,255,255,0.45);
    line-height: 1.6; padding-left: 14px; position: relative;
  }
  .cr-terms-item::before {
    content: '—'; position: absolute; left: 0;
    color: #D4AF37; font-size: 10px; top: 3px;
  }
  .cr-terms-item strong { color: rgba(255,255,255,0.70); }

  .cr-fine-print {
    font-size: 11px; color: rgba(255,255,255,0.20);
    text-align: center; margin-top: 18px; line-height: 1.7;
  }

  .cr-alert {
    border-radius: 10px; padding: 14px 18px;
    font-size: 14px; margin-bottom: 20px; line-height: 1.5;
  }
  .cr-alert-error  { background: rgba(200,50,50,0.12);  border: 1px solid rgba(200,50,50,0.35);  color: #f8a0a0; }

  .cr-ty-hero {
    background: #0A0A0A;
    border-bottom: 1px solid rgba(212,175,55,0.35);
    padding: 36px 24px 44px; text-align: center;
    position: relative; overflow: hidden;
  }
  .cr-ty-hero::before {
    content: ''; position: absolute; inset: 0;
    background: radial-gradient(ellipse at 50% -20%, rgba(212,175,55,0.13) 0%, transparent 60%);
    pointer-events: none;
  }
  .cr-ty-badge {
    display: inline-flex; align-items: center; gap: 10px;
    background: linear-gradient(135deg, rgba(212,175,55,0.14), rgba(212,175,55,0.04));
    border: 1px solid rgba(212,175,55,0.35);
    border-radius: 50px; padding: 10px 26px; margin-bottom: 22px; position: relative;
  }
  .cr-ty-badge span  { font-size: 20px; }
  .cr-ty-badge strong{ font-size: 13px; font-weight: 700; color: #D4AF37; letter-spacing: 0.06em; text-transform: uppercase; }
  .cr-ty-hero h2 {
    font-size: 30px; font-weight: 900; margin-bottom: 12px;
    line-height: 1.15; letter-spacing: -0.4px;
  }
  .cr-ty-hero p {
    font-size: 15px; color: rgba(255,255,255,0.70);
    max-width: 420px; margin: 0 auto; line-height: 1.65;
  }
  .cr-ty-body {
    max-width: 560px; margin: 0 auto;
    padding: 32px 24px 52px;
    display: flex; flex-direction: column; gap: 14px;
  }
  .cr-ty-card {
    background: #111111;
    border: 1px solid rgba(212,175,55,0.12);
    border-radius: 12px; padding: 20px 22px;
  }
  .cr-ty-card-label {
    font-size: 10px; font-weight: 700; letter-spacing: 0.16em;
    text-transform: uppercase; color: #D4AF37; margin-bottom: 10px;
  }
  .cr-ty-card p { font-size: 14px; color: rgba(255,255,255,0.70); line-height: 1.65; margin: 0; }
  .cr-ty-card strong { color: #FFFFFF; }
  .cr-social-links { display: flex; gap: 10px; flex-wrap: wrap; }
  .cr-social-link {
    display: inline-block;
    background: #1A1A1A; border: 1px solid rgba(212,175,55,0.25);
    border-radius: 8px; padding: 11px 20px;
    color: #D4AF37; font-size: 13px; font-weight: 600;
    text-decoration: none; flex: 1; text-align: center;
    transition: background 0.2s, border-color 0.2s;
  }
  .cr-social-link:hover { background: #222222; border-color: #D4AF37; }
`;

export function CompetitionRegisterPage() {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState('');

  const fullNameRef = useRef<HTMLInputElement>(null);
  const emailRef    = useRef<HTMLInputElement>(null);
  const phoneRef    = useRef<HTMLInputElement>(null);
  const agencyRef   = useRef<HTMLInputElement>(null);
  const portalRef   = useRef<HTMLSelectElement>(null);
  const messageRef  = useRef<HTMLTextAreaElement>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
      await apiClient.post('/portal-launch/register', {
        fullName:      fullNameRef.current?.value.trim() ?? '',
        email:         emailRef.current?.value.trim() ?? '',
        phone:         phoneRef.current?.value.trim() ?? '',
        agencyName:    agencyRef.current?.value.trim() ?? '',
        currentPortal: portalRef.current?.value ?? '',
        message:       messageRef.current?.value.trim() ?? '',
      });
      setIsSuccess(true);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (err: any) {
      const status = err?.response?.status;
      const msg = err?.response?.data?.message || err?.response?.data?.error;
      if (status === 409) {
        setError('This email is already registered. Our team will be in touch!');
      } else {
        setError(msg || 'Something went wrong. Please try again.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="comp-reg-root">
      <style dangerouslySetInnerHTML={{ __html: CSS }} />

      {isSuccess ? (
        <div>
          <div className="cr-ty-hero">
            <img className="cr-logo" src={logoImg} alt="Something Property" />
            <div className="cr-ty-badge"><span>🏆</span><strong>You're In</strong></div>
            <h2>Thank You for Registering</h2>
            <p>You're officially entered into the Something Property June Launch Competition. Welcome to the team.</p>
          </div>
          <div className="cr-ty-body">
            <div className="cr-ty-card">
              <div className="cr-ty-card-label">What Happens Next</div>
              <p>Our <strong>Biz Dev team will contact you within 24 hours</strong> to get your profile set up on the portal. Once you're live, you can start listing properties and submitting OTPs right away.</p>
            </div>
            <div className="cr-ty-card">
              <div className="cr-ty-card-label">Competition Period</div>
              <p>Submit OTPs throughout <strong>June 2026</strong>. The agent with the highest qualifying OTP value at the end of June wins the <strong>R50,000 prize</strong>. Winner announced in July on our social media.</p>
            </div>
            <div className="cr-ty-card">
              <div className="cr-ty-card-label">Follow Us — Winner Announced on Social Media</div>
              <div className="cr-social-links">
                <a className="cr-social-link" href="https://instagram.com/somethingproperty" target="_blank" rel="noopener noreferrer">Instagram</a>
                <a className="cr-social-link" href="https://facebook.com/somethingproperty" target="_blank" rel="noopener noreferrer">Facebook</a>
                <a className="cr-social-link" href="https://linkedin.com/company/somethingproperty" target="_blank" rel="noopener noreferrer">LinkedIn</a>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="cr-header">
            <img className="cr-logo" src={logoImg} alt="Something Property" />
            <div className="cr-prize-badge">Win R50,000</div>
            <h1>June Launch Competition</h1>
            <p>One winner takes all. Submit the most qualifying OTPs in June and walk away with R50,000. Winner announced on our social media in July.</p>
          </div>

          <div className="cr-steps">
            <div className="cr-steps-inner">
              <h2>How to Win</h2>
              <div className="cr-step-list">
                <div className="cr-step">
                  <div className="cr-step-num">1</div>
                  <div><strong>Register below</strong> — our Biz Dev team will contact you to get set up as a Something Property agent</div>
                </div>
                <div className="cr-step">
                  <div className="cr-step-num">2</div>
                  <div><strong>List your properties</strong> on the Something Property portal</div>
                </div>
                <div className="cr-step">
                  <div className="cr-step-num">3</div>
                  <div><strong>Submit the most OTPs</strong> during June 2026 — qualify with R5,000,000+ in OTP value and a 60% approval rate</div>
                </div>
                <div className="cr-step">
                  <div className="cr-step-num">4</div>
                  <div><strong>Follow @SomethingProperty</strong> on Instagram, Facebook and LinkedIn — winner announced on social media in July</div>
                </div>
              </div>
            </div>
          </div>

          <div className="cr-form-wrap">
            <div className="cr-form-title">Register for the Competition</div>
            <div className="cr-form-subtitle">Fill in your details and we'll be in touch within 24 hours.</div>
            <div className="cr-form-divider"></div>

            {error && <div className="cr-alert cr-alert-error">{error}</div>}

            <form onSubmit={handleSubmit}>
              <div className="cr-row">
                <div className="cr-field">
                  <label className="cr-label">Full Name *</label>
                  <input ref={fullNameRef} className="cr-input" type="text" placeholder="Jane Smith" required />
                </div>
                <div className="cr-field">
                  <label className="cr-label">Email Address *</label>
                  <input ref={emailRef} className="cr-input" type="email" placeholder="jane@agency.co.za" required />
                </div>
              </div>

              <div className="cr-row">
                <div className="cr-field">
                  <label className="cr-label">Phone Number *</label>
                  <input ref={phoneRef} className="cr-input" type="tel" placeholder="082 000 0000" required />
                </div>
                <div className="cr-field">
                  <label className="cr-label">Agency / Brokerage</label>
                  <input ref={agencyRef} className="cr-input" type="text" placeholder="Your Agency Name" />
                </div>
              </div>

              <div className="cr-field">
                <label className="cr-label">Which portal are you currently on?</label>
                <select ref={portalRef} className="cr-select">
                  <option value="">Select a portal…</option>
                  <option>Property24</option>
                  <option>Private Property</option>
                  <option>MyProperty</option>
                  <option>Gumtree</option>
                  <option>None / Other</option>
                </select>
              </div>

              <div className="cr-field">
                <label className="cr-label">Anything else? (optional)</label>
                <textarea ref={messageRef} className="cr-textarea" placeholder="Any questions or info you'd like us to know…" />
              </div>

              <button type="submit" className="cr-submit-btn" disabled={isLoading}>
                {isLoading ? 'Registering…' : 'Register & Enter to Win'}
              </button>

              <div className="cr-terms-box">
                <h4>Terms &amp; Conditions</h4>
                <ul className="cr-terms-list">
                  <li className="cr-terms-item">There is <strong>1 winner</strong> — the agent with the highest qualifying OTP value takes the full <strong>R50,000 prize</strong>.</li>
                  <li className="cr-terms-item">To qualify, an agent must submit a minimum of <strong>R5,000,000 worth of OTPs</strong> during June 2026.</li>
                  <li className="cr-terms-item">To qualify, an agent must achieve a minimum <strong>60% bond approval rate</strong> on submitted OTPs.</li>
                  <li className="cr-terms-item">Agents who do not meet both qualifying conditions are not eligible regardless of OTP volume.</li>
                  <li className="cr-terms-item">Competition open to registered Something Property agents only. Period: 1–30 June 2026.</li>
                  <li className="cr-terms-item">Winner announced on Something Property social media in July 2026. Something Property's decision is final.</li>
                </ul>
              </div>

              <div className="cr-fine-print">
                By registering you agree to be contacted by the Something Property Biz Dev team and accept the T&amp;Cs above.
              </div>
            </form>
          </div>
        </>
      )}
    </div>
  );
}
